<aside class="landing-side-nav">
  <div class="landing-side-nav-content">
    <ngx-landing-breakpoints></ngx-landing-breakpoints>
    <ngx-landing-options [ngClass]="{ 'd-none': !event || !persona }"></ngx-landing-options>
    <ngx-landing-embed-code [eventSlug]="event?.slug" [form]="persona" [isLoading]="isLoading"></ngx-landing-embed-code>
    <ngx-landing-mirror-links
      [eventSlug]="event?.slug"
      [formSlug]="persona?.slug"
      [formLink]="formLink"
      [rawFormLink]="rawFormLink"
      [isLoading]="isLoading"
    ></ngx-landing-mirror-links>
    <ngx-landing-qr-code *ngIf="formLink" [qrData]="formLink" [qrDownloadName]="qrDownloadName"></ngx-landing-qr-code>
  </div>
  <div class="landing-side-nav-footer">
    <button (click)="publishLandingPage()" class="publish-button">Publish Changes</button>
  </div>
</aside>
